import loadable from '@loadable/component';

export const PaymentViewContainerLoadable = loadable(
  () => import('./PaymentViewContainer'),
  { resolveComponent: (module) => module.PaymentViewContainer, ssr: false },
);
